import { render } from "./Confidence.vue?vue&type=template&id=645ba97f&ts=true"
import script from "./Confidence.vue?vue&type=script&lang=ts"
export * from "./Confidence.vue?vue&type=script&lang=ts"

import "./Confidence.vue?vue&type=style&index=0&id=645ba97f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__